import { useState } from 'react'
import { UserIcon, CalendarsIcon, LightningIcon, InsightsIcon } from '@/components/icons'
import { CalendarIntegrationsDialog } from '@/components/integrations/calendar-integrations-dialog'
import { AutomationRulesDialog } from '@/components/automation-rules/automation-rules-dialog'
import { PreferencesDialog, AnalyticsDialog, SettingsCard } from '@/components/settings'

export function SettingsPage() {
  // Dialog states
  const [isCalendarIntegrationsDialogOpen, setIsCalendarIntegrationsDialogOpen] = useState(false)
  const [isAutomationRulesDialogOpen, setIsAutomationRulesDialogOpen] = useState(false)
  const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = useState(false)
  const [isAnalyticsDialogOpen, setIsAnalyticsDialogOpen] = useState(false)

  return (
    <>
      <div className="main-content">
        <SettingsCard
          icon={<UserIcon />}
          title="Preferences"
          description="Customize your timezone, week start day, and theme preferences."
          onClick={() => setIsPreferencesDialogOpen(true)}
          className="mb-8"
        />
        
        <SettingsCard
          icon={<CalendarsIcon />}
          title="Calendar integrations"
          description="Connect your calendar provider accounts to create automation rules and enable analytics."
          onClick={() => setIsCalendarIntegrationsDialogOpen(true)}
          className="mb-8"
        />
        
        <SettingsCard
          icon={<LightningIcon />}
          title="Automation Rules"
          description="Create automation rules that update your calendar's events color."
          onClick={() => setIsAutomationRulesDialogOpen(true)}
          className="mb-8"
        />
        
        <SettingsCard
          icon={<InsightsIcon />}
          title="Analytics"
          description="Setup analytics to track your calendars' time allocation."
          onClick={() => setIsAnalyticsDialogOpen(true)}
          className="mb-8"
        />
      </div>
      
      {/* Calendar Integrations Dialog */}
      <CalendarIntegrationsDialog
        open={isCalendarIntegrationsDialogOpen}
        onClose={() => setIsCalendarIntegrationsDialogOpen(false)}
      />
      
      {/* Automation Rules Dialog */}
      <AutomationRulesDialog
        open={isAutomationRulesDialogOpen}
        onClose={() => setIsAutomationRulesDialogOpen(false)}
      />
      
      {/* Preferences Dialog */}
      <PreferencesDialog
        open={isPreferencesDialogOpen}
        onClose={() => setIsPreferencesDialogOpen(false)}
      />
      
      {/* Analytics Dialog */}
      <AnalyticsDialog
        open={isAnalyticsDialogOpen}
        onClose={() => setIsAnalyticsDialogOpen(false)}
      />
    </>
  )
}
